import { FieldValues } from 'react-hook-form';

import { IFormStorage, WatchedValues } from './types';

class FormMemoryStorage<TFieldValues extends FieldValues> implements IFormStorage<TFieldValues> {
  private map = new Map();

  getItem(key: string) {
    return this.map.get(key);
  }

  setItem(key: string, values: WatchedValues<TFieldValues>) {
    this.map.set(key, values);
  }

  removeItem(key: string) {
    this.map.delete(key);
  }
}

const formMemoryStorage = new FormMemoryStorage();

export { formMemoryStorage };
